import classNames from "classnames";
import Box from "pages/_components/Box";
import Button from "pages/_components/Button";
import { resizableRoute } from "pages/_components/Resizable";
import { bool, func, number, shape } from "prop-types";
import React, { useState } from "react";
import withRouter from "react-router-dom/withRouter";
import * as i18nUtils from "util/i18n";

const ChipsButtonsGroup = ({ buttonsGroup, isDesktop, defaultSelect, onClickHandler, buttonsGap }) => {
    const [selectedIdButton, setSelectedIdButton] = useState(defaultSelect);

    const handlerSelectButton = (buttonId) => {
        setSelectedIdButton(buttonId);
        if (typeof onClickHandler === "function") {
            onClickHandler(buttonId);
        }
    };
    return (
        <Box
            component="nav"
            aria-label={i18nUtils.get("global.navTypes.a11y")}
            display="flex"
            gap={buttonsGap}
            alignX={isDesktop ? "center" : "evenly"}>
            {buttonsGroup.map((button) => (
                <Button
                    key={button.id}
                    className={classNames({
                        "is-active": button?.id === selectedIdButton || button?.selected,
                    })}
                    label={button?.label}
                    onClick={() => {
                        handlerSelectButton(button.id);
                    }}
                    {...((button?.id === selectedIdButton || button?.selected) && { image: "images/check.svg" })}
                    bsStyle="chip"
                    disabled={button?.permission}
                />
            ))}
        </Box>
    );
};

ChipsButtonsGroup.propTypes = {
    buttonsGroup: shape.isRequired,
    isDesktop: bool.isRequired,
    onClickHandler: func.isRequired,
    defaultSelect: number,
    buttonsGap: bool,
};
ChipsButtonsGroup.defaultProps = {
    defaultSelect: null,
    buttonsGap: "5",
};

export default resizableRoute(withRouter(ChipsButtonsGroup));
